export default __webpack_public_path__ + "static/media/NO28_NFT003M.d415e46b.mp4";